import { VENDOR_SERVICES, type VendorService } from '../enums/vendor-service.enum.js'

/**
 * What couples look for vendors in (docs/vendor-growth.spec.md, "Couples find
 * vendors"): everything but furniture, which they rent in the floor plan.
 */
export const DIRECTORY_SERVICES = VENDOR_SERVICES.filter((s): s is Exclude<VendorService, 'furniture'> => s !== 'furniture')

export type DirectoryService = (typeof DIRECTORY_SERVICES)[number]

/** Vendors per category in the couple's "Find vendors" on its event page; the rest are a "See all" away. */
export const EVENT_PAGE_VENDORS_PER_CATEGORY = 3

/** A sanity cap on a venue's vendors read at once. */
export const DIRECTORY_MAX_VENDORS = 500
